
// @ts-nocheck





import { i18nText } from '@/locales';


import { FiltersData, getRouteFilter, setRouteFilter, getRouteFilterObject } from "@/entity/filters/extFilter";
import { RouterNameEnum } from "@/router/router.types";
import dayjs from "dayjs";
import moment from "moment";
import customParseFormat from "dayjs/plugin/customParseFormat";
import { RouterProperties } from "@/router/routerProperties";
import PageTitle from "@/UI/components/common/PageTitle.vue";
import { AppFilters } from "@/UI/components/extFilter/AppFilters";
import AppFilterTable from "@/UI/components/extFilter/AppFilterTable.vue";
import { ProxyTableData } from "@/UI/components/Helpers/ProxyTableData";
import BaseDataForm from "@/UI/components/Helpers/BaseForm/BaseDataForm.vue";
import { CityMix } from "@/UI/mixins/CityMix";
import { mixins } from "vue-class-component";
import { Component, Vue } from "vue-property-decorator";
import { Button, Menu, List, Table, Select } from "ant-design-vue";
import { HandleScrollStore, HandleScrollStorewithParam, SearchinStore } from "@/UI/Decorators/decorator";
import { notSelected } from "@/UI/components/Helpers/ProxyTableTypes";
import { TableColumns } from "@/UI/pages/salons/lib/table"
import SortComponent from "@/UI/components/Helpers/components/SortComponent.vue"
import { PartnerStore } from "@/store/modules/Partner";
import { SalonsStore } from "@/store/modules/Salons";
import {ManagerStore} from "@/store/modules/Manager";
import {appFiltersStore} from "@/store/modules/appFilters";
import {ProxyGetData} from "@/UI/components/Helpers/getData";
import {appPaginationStore} from "@/store/modules/appPagination";
import {NewProxyDataForm} from '@/UI/components/Helpers/NewProxyDataForm';
import { getStudioId } from "@/UI/lib/state";

dayjs.extend(customParseFormat);

@Component({
    components: {
        "a-button": Button,
        "a-menu-item": Menu.Item,
        "a-list-item": List.Item,
        "a-list-item-meta": List.Item.Meta,
        "a-select": Select,
        "a-select-option": Select.Option,
        "a-table": Table,
        PageTitle,
        AppFilterTable,
        BaseDataForm,
        SortComponent
    },
    methods: {
        setRouteFilter,
        getRouteFilter,
    },
})

export default class Salons extends mixins(
    ProxyGetData,
    ProxyTableData,
    CityMix,
    TableColumns,
) {
    notSelected = notSelected;
    filtersData = new FiltersData();
    checkRole: boolean = false;
    disabledDateToOpeningDate: string = "";

    createStudio(): void {
        Vue.router.push({ name: RouterNameEnum.SalonCreation });
    }

    @SearchinStore
    hSearch(source: string, value: string, exist_studios: boolean): void {}
    @SearchinStore
    hSearchwp(source: string, value: string, useStudio: boolean, name?: string, filter?: any): void {}
    @HandleScrollStore
    hScroll(event: any, value: string): void {}
    handleSearch(source: string, value: string): void {
        this.hSearch(source, value, true);
    }
    handleScroll(event: any, value: string): void {
        this.hScroll(event, value);
    }
    handleSearchWithParam(source: string, value: string, useStudio: boolean, name?: string, filter?: any): void {
        this.hSearchwp(source, value, useStudio, name, filter);
    }
    @HandleScrollStorewithParam
    hScrollParam(event: any, value: string, value2: string, exist_studios: boolean): void {}
    handleScrollCity(event: any): void {
        this.hScrollParam(event, "territory", "cities", true);
    }

    customRow = (record: any) => {
        return {
            on: {
                click: async (event: any) => {
                    await this.$store.commit("changeSalon", record.id);
                    await this.$router.push({ name: RouterNameEnum.SalonDetail, params: { id: record.id } });
                },
            },
        };
    };

    isCurrentBranch(record: any): boolean {
        return Number(this.$store.state.salon_id) > 0 && Number(record.id) === Number(this.$store.state.salon_id);
    }

    branchRowClass(record: any): string {
        return this.isCurrentBranch(record) ? 'pult-branch-current' : '';
    }

    async created(): Promise<void> {
        if (!this.formReady) {
            this.messageAlert(i18nText("Подождите немного"))
            this.proxyFilter = {}
            appPaginationStore.setCurrent(1)
            try {
                this.checkRole = !Vue.auth.check("admin");
                await this.createProxy();
                if (Vue.auth.check('admin')) await this.fetchModule([
                    {s: 'territory', p: {limit: this.AppPageParams.pageSize}},
                    {s: 'partner', p: {limit: this.AppPageParams.pageSize, filter: {exist_studios: true}}},
                ])
                this.setFilters(this);
            } catch (e) {
                console.error(e);
            } finally {
                this.formReady = true;
                this.table_load = false;
            }
        }
    }

    get partner(): any { return PartnerStore.partner }
    get manager(): any { return ManagerStore.manager }
    get salons(): any { return SalonsStore.salons }

    setFilters(that: any): void {
        this.filtersData.filters.push (
            {
                key: 0,
                type: "sourceVuex",
                label: i18nText("Партнер"),
                vuexSource: "partner",
                storeVuexSource: "partner",
                noDataTag: true,
                defaultValue: 0,
                value: Number(getRouteFilter("partner_id")),
                default_value: [i18nText("Не указано")],
                filtered: false,
                async onChange(value: any) {
                    // ----- refresh list when Не указано chosen (Starting line.) -----
                    if (value == 0) {
                        that.hSearchwp("partner", " ", false, "name", {});
                    }
                    // ----- refresh list when Не указано chosen (Ending line.) -----
                    await that.setRouteFilterTable(RouterProperties.salons, { partner_id: value }, false);
                },
                async onSearch(value: any) {
                    if (value.length > 0) {
                        that.hSearchwp("partner", value, false, "name", {
                            name: value,
                        });
                    } else {
                        await that.fetchModule([
                            {s: 'partner', p: {limit: that.AppPageParams.pageSize, filter: {exist_studios: true}}}
                        ])
                    }
                },
            },
            {
                key: 1,
                type: "sourceVuex",
                label: i18nText("Город"),
                defaultValue: 0,
                value: Number(getRouteFilter("city_id")),
                default_value: [i18nText("Не указано")],
                vuexSource: "cities",
                storeVuexSource: "territory",
                storeSource: AppFilters.cities,
                filtered: false,
                async onChange(value: any) {
                    // ----- refresh list when Не указано chosen (Starting line.) -----
                    if (value == 0) {
                        that.handleSearch("territory", " "); 
                    }
                    // ----- refresh list when Не указано chosen (Ending line.) -----
                    await that.setRouteFilterTable(RouterProperties.salons, { city_id: value }, false);
                },
                async onSearch(value: any) {
                    that.handleSearch("territory", value);
                    
                },
                async onScroll(value: any) {
                    that.handleScrollCity(value);
                },
            },
            {
                key: 3,
                type: "select",
                label: i18nText("Активность"),
                defaultValue: Number(getRouteFilter("active")),
                default_value: [i18nText("Не указано")],
                value: [
                    {
                        label: i18nText("Не указано"),
                        key: "0",
                    },
                    {
                        label: i18nText("Активный"),
                        key: "1",
                    },
                    {
                        label: i18nText("Не активный"),
                        key: "2",
                    },
                ],
                fieldNames: ["active"],
                filtered: false,
                async onChange(value: any) {
                    console.log("VAL", value)
                    let filter: any = {};
                    if (value === "0") {
                        filter = { active: "0" };
                    } else {
                        filter = { active: JSON.stringify(value === "1") };
                    }
                    await that.setRouteFilterTable(RouterProperties.salons, filter, false);
                },
            },
            {
                key: 4,
                type: "date",
                label: i18nText("Дата открытия (от)"),
                defaultValue: 0,
                placeholder: "",
                value: Number(getRouteFilter("conclusion_contract_date")),
                fieldNames: ["conclusion_contract_date"],
                filtered: false,
                disabledDate: (current: any) => {

                    // disable opening_date_from to choose the dates that later than opening_date
                    const allFilterJSON = getRouteFilterObject();
                    if(allFilterJSON) {
                        const allFilter = JSON.parse(allFilterJSON);
                        if("opening_date" in allFilter) {
                            return current && current > dayjs(allFilter["opening_date"], "DD.MM.YYYY").endOf('day');
                        }
                    }
                    return false;
                },
                async onChange(value: any) {
                    let filter = {}
                    if (value) filter = { opening_date_from: value.format("DD.MM.YYYY") }
                    else filter = { opening_date_from: "0" }
                    await that.setRouteFilterTable(RouterProperties.salons, filter, false );
                    const allFilterJSON = await getRouteFilterObject();
                    const allFilter = JSON.parse(allFilterJSON);

                    // If user set opening_date earlier than opening_date_from which is not possible (before we check that this two dates is in filter)
                    if("opening_date_from" in allFilter && "opening_date" in allFilter) {
                        const openingDate = dayjs(allFilter["opening_date"], "DD.MM.YYYY");
                        const openingDateFrom = dayjs(allFilter["opening_date_from"], "DD.MM.YYYY");

                        // If user set opening_date earlier than opening_date_from we set to filter opening_date equal 0
                        if(openingDate.isBefore(openingDateFrom)) {
                            filter = { opening_date: "0" }
                            /* filter = { opening_date_from: getRouteFilter("opening_date") }
                            value = moment(openingDate.toDate()); */
                            await that.setRouteFilterTable(RouterProperties.salons, filter, false);
                        }
                    }
                },
            },
            {
                key: 5,
                type: "date",
                label: i18nText("Дата открытия (до)"),
                defaultValue: 0,
                placeholder: "",
                value: Number(getRouteFilter("opening_date")),
                filtered: false,
                disabledDate: (current: any) => {

                    // disable opening_date to choose the dates that earlear than opening_date_from 
                    const allFilterJSON = getRouteFilterObject();
                    if(allFilterJSON) {
                        const allFilter = JSON.parse(allFilterJSON);
                        if("opening_date_from" in allFilter) {
                            return current && current < dayjs(allFilter["opening_date_from"], "DD.MM.YYYY").endOf('day');
                        }
                    }
                    return false;
                },
                async onChange(value: any) {
                    let filter = {}
                    if (value) filter = { opening_date: value.format("DD.MM.YYYY") }
                    else filter = { opening_date: "0" }
                    await that.setRouteFilterTable(RouterProperties.salons, filter, false);
                },
            },
        )
        if (this.checkRole) this.filtersData.filters = this.filtersData.filters.filter(filter => filter.type !== 'sourceVuex');
        this.filter_load = true
    }

    async setFilter({by, sort}: { by: string; sort: any }): Promise<void> {
        await this.filterData(appFiltersStore.filter)
        // Новый объект с сортировкой (asc - по возростанию) (desc - по убыванию)
        let sortFieldName = sort.sortField !== undefined ? sort.sortField : undefined;

        if (!sortFieldName && sort.key !== undefined)
            sortFieldName = sort.key;

        if (!sortFieldName && sort.dataIndex !== undefined)
            sortFieldName = sort.dataIndex;

        await this.sortedData(by, {dataIndex: sortFieldName})
    }

    async clearFilter(clear: string): Promise<void> {
        await this.sortedData('desc', {dataIndex: 'created_at'})
    }

    async clearAFilter(): Promise<void> {
        console.log("clearAFilter")
        this.proxyFilter = {
            salon_id: getStudioId(this)
        }
        for (let i of this.filtersData.filters) {
            i.default_value = [i18nText("Не указано")]
        }
        await this.sortedData('desc', {dataIndex: 'created_at'})
    }
}
